import { Table } from 'antd';
import { useState } from 'react';
import { ZorbaButton } from '../../../../../../components/forms';
import { BUTTON_VARIANT_LINK } from '../../../../../../components/forms/ZorbaButton/constants';
import { showErrorToast } from '../../../../../../services/notificationsService';
import { postRequest } from '../../../../../../services/requestService';
import {
  BULK_SUBMIT_SELECT_SOURCE,
  BULK_SUBMIT_SUBMITTED,
} from '../../constants';
import { getTableColumns } from './constants';

import './index.scss';

export const ConfirmDetails = ({
  data,
  setWizardStep,
  setIsLoading,
  isLoading,
  duplicatesCounter,
}) => {
  const [tableData, setTableData] = useState(data);
  const [editingKey, setEditingKey] = useState(null);
  const [tempValue, setTempValue] = useState(null);

  const handleChange = (value) => {
    setTempValue(value != null ? value : null);
  };

  const saveValue = (key, index) => {
    const newData = [...tableData];
    newData[index][key] = tempValue !== null ? tempValue : null;
    setTableData(newData);
    setEditingKey(null);
    setTempValue(null);
  };

  const handleCellClick = (index, key, currentValue) => {
    setEditingKey(`${index}-${key}`);
    setTempValue(currentValue);
  };

  const handleStartOver = () => {
    setWizardStep(BULK_SUBMIT_SELECT_SOURCE);
  };

  const countValidRecords = () =>
    tableData.filter(
      (record) =>
        record.askingPrice != null &&
        record.bedroom != null &&
        record.bathroom != null &&
        record.yearBuilt != null &&
        record.propertyAddress != null,
    ).length;

  const validRecords = countValidRecords();

  const handleDelete = (index) => {
    const newData = [...tableData];
    newData.splice(index, 1);
    setTableData(newData);
    if (!newData?.length) {
      setWizardStep(BULK_SUBMIT_SELECT_SOURCE);
    }
  };

  const handleContinue = async () => {
    try {
      setIsLoading(true);
      await postRequest('/pre-deal/bulk-submit', {
        data: tableData.map((record) => ({
          ...record,
          bathroom: Number(record.bathroom),
          bedroom: Number(record.bedroom),
          askingPrice: Number(record.askingPrice),
          yearBuilt: Number(record.yearBuilt),
        })),
      });
      setIsLoading(false);
      setWizardStep(BULK_SUBMIT_SUBMITTED);
    } catch (error) {
      showErrorToast('Submitting deals failed. Please try again!');
      setIsLoading(false);
    }
  };

  return (
    <div className="confirm-details">
      <div className="title-container">
        <div className="left">
          <span className="title">Update missing info</span>
          <span className="description">
            Total records:{' '}
            <strong>{tableData.length + duplicatesCounter}</strong> | Valid:{' '}
            <strong>{validRecords}</strong> | Invalid:{' '}
            <strong>{tableData.length - validRecords}</strong>
            {duplicatesCounter > 0 && (
              <>
                {' '}
                | Duplicates: <strong>{duplicatesCounter}</strong>
              </>
            )}
          </span>
        </div>
        <div className="right">
          <ZorbaButton
            variant={BUTTON_VARIANT_LINK}
            onClick={handleStartOver}
            disabled={isLoading}
          >
            Start Over
          </ZorbaButton>
          <ZorbaButton
            disabled={
              !tableData?.length ||
              tableData?.length !== validRecords ||
              isLoading
            }
            onClick={handleContinue}
          >
            Continue
          </ZorbaButton>
        </div>
      </div>
      <div className="table-container">
        <Table
          columns={getTableColumns({
            handleChange,
            editingKey,
            saveValue,
            handleCellClick,
            tempValue,
            handleDelete,
          })}
          loading={isLoading}
          dataSource={tableData}
          pagination={false}
          rowKey={(_, index) => index}
        />
      </div>
    </div>
  );
};
